'use strict';

// Vue:
import Vue from 'vue';

// Vue mixins:
import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';

// Vue directives:

// Vue components:
import { ssoTogglaRaderIDatatable } from 'v-components/ssoTogglaRaderIDatatable';

import euiDocumentViewerDialog from 'v-components/euiDocumentViewerDialog';

// Vue store:
import { ssoStatestore as store } from 'v-store/ssoStatestore';	// 'store' för jag vet inte om/hur jag kan använda ett annat namn nedan :(

// Övrigt:
import { ssoTooltips } from 'ssoTooltips';
import { ssoVerifikatDatatable } from 'datatables/ssoVerifikatDatatable';
import SetOrUpdateClassOnFirstAndLastNonHiddenChild from 'SetOrUpdateClassOnFirstAndLastNonHiddenChild';

//------------------------------------------------------------------------------------------------------------------------------

// Använd dessa Vue plugins:
Vue.use(ssoTogglaRaderIDatatable);

window.ssoVerifikat = window.ssoVerifikat || {};	// För att undvika ESLint-varningar att den är odefinierad.

// Todo: Temp.. *kanske*!
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.performance = process.env.NODE_ENV !== 'production';	// Inspekterbart i web tools flik Performance.


//##############################################################################################################################

//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	store,	// ssoStatestore

	// Lokalt registrerade komponenter
	components: {
		euiDocumentViewerDialog,
	},

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	// Data utöver de från mixin ovan:
	data: {
		tabellen: null,		// Initialt så. null betyder 'ännu inte satt'

		radtexterInaktiverad: window.ssoVerifikat.radtexterInaktiverad,
		rattelserInaktiverad: window.ssoVerifikat.rattelserInaktiverad,

		hovrarFotnot1: false,	// Initialt så.

		visaArkiveratDokumentDialog: false,
		dokumentDbId: 0,
		dokumentRekar: 0,
		dokumentFilnamn: undefined,
		dokumentFilnamnUrlEscapead: undefined,
		dokumentXXHash: undefined,
		dokumentOriginalfilUrlSegmentTill: undefined,

		// Ytterligare data finns i ssoStateStore!
	},

	computed: {

		radtexterVisas: {
			// getter
			get()
			{
				return this.$store.state.verifikat.radtexterVisas;
			},
			// setter
			set(value)
			{
				this.$store.commit('verifikat/setRadtexterVisas', value)
			}
		},

		rattelserVisas: {
			// getter
			get()
			{
				return this.$store.state.verifikat.rattelserVisas;
			},
			// setter
			set(value)
			{
				this.$store.commit('verifikat/setRattelserVisas', value)
			}
		},
	},

	watch: {

		radtexterVisas(nyttVarde, tidigareVarde)
		{
			SetOrUpdateClassOnFirstAndLastNonHiddenChild('#_ss-tabellen_kropp tbody');

			// Inte i detta fall, då de nya raderna aldrig kan ha tooltips:
			//if (nyttVarde)
			//{
			//	// Nya rader ska visas och har därmed lagts till i tabellen:
			//	// Tooltips måste bindas om:
			//	ssoTooltips.ominitiera();
			//}
		},

		rattelserVisas(nyttVarde, tidigareVarde)
		{
			SetOrUpdateClassOnFirstAndLastNonHiddenChild('#_ss-tabellen_kropp tbody');

			// Inte i detta fall, då de nya raderna aldrig kan ha tooltips:
			//if (nyttVarde)
			//{
			//	// Nya rader ska visas och har därmed lagts till i tabellen:
			//	// Tooltips måste bindas om:
			//	ssoTooltips.ominitiera();
			//}
		},

		visaArkiveratDokumentDialog(nyttVarde, tidigareVarde)
		{
			// Flyttat in i komponenten:
			//if (nyttVarde == false
			//	&& window.ssoVerifikat.documentViewerInstance
			//)
			//{
			//	window.ssoVerifikat.documentViewerInstance.dispose();
			//	window.ssoVerifikat.documentViewerInstance = undefined;

			//	window.ssoVerifikat.documentViewerDialogThis = undefined;

			//	window.ssoVerifikat.documentViewerFirstPageRendered = false;
			//}
		},
	},

	methods: {
		onTogglingAvRadtexterEllerRattelser(skaVisas)
		{
			// Vid klick/toggling på någon av de "generiska kryssrutorna" på sidan:
			// Detta behövs för att "kryssrutorna" äter upp klick/toggling och då släcks inte eventuella synliga tooltips:
			ssoTooltips.doljAlla();

			// Ytterligare åtgärder finns i 'watch:'!
		},

		onArkivfilTryckt(dbId, rekar, filnamn, filnamnUrlEscapead, dokumentOriginalfilUrlSegmentTill, xXHash)
		{
			this.dokumentDbId = dbId;
			this.dokumentRekar = rekar;
			this.dokumentFilnamn = filnamn;
			this.dokumentFilnamnUrlEscapead = filnamnUrlEscapead;
			this.dokumentXXHash = xXHash;
			this.dokumentOriginalfilUrlSegmentTill = dokumentOriginalfilUrlSegmentTill;

			this.visaArkiveratDokumentDialog = true;
		},
	},


	//== Lifecycle hooks  ================================================================================================================

	beforeCreate()
	{
		// Called synchronously immediately after the instance has been initialized, before data observation and event/watcher setup.

		// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
		// Dessa används för att styra funktionalitet i mixin "ssoAllaSidorMixin":
		// Defaultvärde sätts numera i mixinen: this.$_rullningsbaraElementQuerySelectorAll = '.-rullningsbar-auto, .-rullningsbar-overlay, .-rullningsbar-auto-persist, .-rullningsbar-overlay-persist';
		this.$_vuexNamespace = 'verifikat';
	},

	mounted()
	{
		// Note that mounted does not guarantee that all child components have also been mounted.

		console.time('#TIMING: initieraDataTable');	// Todo: TEMP!!!
		this.tabellen = ssoVerifikatDatatable.initiera(window.ssoVerifikat.dataSet);
		console.timeEnd('#TIMING: initieraDataTable');	// Todo: TEMP!!!

		SetOrUpdateClassOnFirstAndLastNonHiddenChild('#_ss-tabellen_kropp tbody');

		//this.$nextTick(function ()
		//{
		//	// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
		//	// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:
		//});
	},
})
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!

export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;
